<template>
  <div>
    <b-modal
      size="lg"
      id="modal-import-tracking"
      v-model="showModal"
      hide-footer
      hide-header
      centered
    >
      <form class="form-box">
        <b-container class="container-box">
          <b-row class="no-gutters">
            <b-col>
              <h1 class="font-weight-bold header-main text-uppercase">
                {{ $t("importprodata") }}
              </h1>
            </b-col>
          </b-row>

          <b-row class="no-gutters bg-white p-3 mt-3">
            <b-col cols="12">
              <UploadFile
                :textFloat="$t('uploadTrackingFile')"
                :placeholder="$t('pleaseUpload')"
                format="excel"
                name="file"
                :text="$t('excelOnly')"
                v-model="form.file"
                :fileName="filename"
                isRequired
                v-on:onFileChange="onExcelChange"
                v-on:delete="deleteFile"
                :v="$v.form.file"
                :isDownloadShow="false"
              />
            </b-col>
            <b-col cols="12">
              <InputSelect
                :title="$t('chooseShippingName')"
                :placeholder="$t('selectShippingName')"
                class="mb-4"
                name="chooseShippingName"
                valueField="id"
                textField="name"
                v-bind:options="shippingList"
                v-model="shippingSelect"
                @onDataChange="handleChangeShipping"
            /></b-col>
            <b-col cols="12">
              <small
                >หมายเหตุ : สำหรับการจัดส่งโดยแบรนด์ จะไม่มีระบบติดตามพัสดุ
                สถานะของคำสั่งซื้อจะเป็นการจัดส่งสำเร็จเมื่อลูกค้ากดยืนยันการรับสินค้า</small
              >
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <b-col md="6">
              <b-button @click="showModal = false" class="btn-details-set">{{
                $t("cancel")
              }}</b-button>
            </b-col>
            <b-col md="6" class="text-sm-right">
              <b-button
                class="btn btn-success btn-details-set ml-md-2 text-uppercase"
                :disabled="isDisable"
                @click="importData"
                >{{ $t("submit") }}
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </form>
    </b-modal>

    <ModalAlert ref="modalAlert" :text="modalMessage" />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import InputSelect from "@/components/inputs/InputSelect";
import UploadFile from "@/components/inputs/UploadFile";
import { required } from "vuelidate/lib/validators";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";

export default {
  name: "ProductImportData",
  components: {
    UploadFile,
    ModalAlert,
    ModalAlertError,
    ModalLoading,
    InputSelect,
  },
  data() {
    return {
      shippingList: [],
      shippingSelect: "",
      showModal: false,
      // isDisable: true,
      hasEmailorOnSubmit: false,
      importerror: false,
      error: true,
      filename: "",
      form: {
        file: "",
        shippingId: "",
      },
      modalMessage: "",
    };
  },
  validations: {
    form: {
      file: { required },
    },
  },
  created: async function() {
    this.$isLoading = true;
  },
  watch: {
    showModal(val) {
      this.form.file = null;
      this.filename = null;
      this.form.shippingId = "";
      // if (!val) {
      //   this.$emit("getList");
      // }
    },
  },
  computed: {
    isDisable() {
      return this.form.shippingId == "" || this.filename == "";
    },
  },
  mounted() {
    this.getShippingList();
  },
  methods: {
    handleChangeShipping(val) {
      this.form.shippingId = val;
    },
    async getShippingList() {
      let data = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/Shipping/List`,
        null,
        this.$headers,
        this.filter
      );

      if (data.result == 1) {
        this.shippingList = data.detail.dataList;
        this.shippingList.splice(0, 0, {
          id: "",
          name: "กรุณาเลือกการขนส่ง",
          disabled: true,
        });
        this.shippingList = this.shippingList.filter(el => el.id != 15);
      }
    },
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    onExcelChange(file) {
      this.filename = file.name;
      // this.isDisable = false;

      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.file = reader.result;
      };
    },
    deleteFile(value) {
      this.form.file = null;
      this.filename = null;
    },
    importData: async function(id) {
      this.$v.form.$touch();

      if (this.$v.form.$error) {
        return;
      }

      this.submit();
    },
    submit: async function(id) {
      // this.isDisable = true;
      this.$refs.modalLoading.show();
      if (this.form.shippingId == "") {
        this.modalMessage = "กรุณาเลือกการขนส่ง";
        return this.$refs.ModalAlertError.show();
      }
      if (this.filename == "") {
        this.modalMessage = "กรุณาอัพโหลดไฟล์";
        return this.$refs.ModalAlertError.show();
      }
      let data = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/ownFleet/ImportOwnFleet`,
        null,
        this.$headers,
        this.form
      );
      this.modalMessage = data.message;
      this.$refs.modalLoading.hide();
      // this.isDisable = false;
      if (data.result == 1) {
        this.$refs.modalAlert.show();
        this.form.file = null;
        this.filename = null;
        this.$v.form.$reset();

        setTimeout(() => {
          this.$refs.modalAlert.hide();
        }, 3000);
        setTimeout(() => {
          this.$emit("getList");
        }, 500);
      }
    },
  },
};
</script>
